<!--
화면명 : SKN 상품조회 팝업(슬라이드)
설  멍 : SKN 상품조회 버튼으로 진입, 
					선택된 상품 및 입력한 상품을 조회하고
					조회된 상품의 호환 결과를 조회하고 선택하여 주문항목을 담음
개발자 : 신태휘
 -->
<template>
  <slidePopup ref="slidePopup">
			<div class="inner">
				<strong class="title">SKN 상품조회</strong>
					<div class="pop_con_wrap scroll_area"   style="height:700px;">
						<div class="search">
							<div class="w900">
								<div class="board_list type01">
									<div class="sub_left_wrap">
										<div class="destxt pb10">상품정보 <span>{{productListRowCnt}}</span>건 </div>
									</div>
									<div class="sub_right_wrap">
										<div class="destxt pb10">상품주문에서 기재된<span>“상품코드” </span>중, 체크된 항목만 조회합니다.</div>
									</div>
									<grid :options="productList_grid" v-once />
								</div>
							</div>
							<!--  -->
							<div class="w900">
								<div class="board_list type02 w900">
									<div class="sub_left_wrap">
										<div class="destxt pb10">선택상품의 호환결과  <span>{{compatibleListRowCnt}}</span>건 </div>
									</div>
									<div class="sub_right_wrap">
										<div class="destxt pb10">담은 주문항목 <span>{{chosenListRowCnt}}</span>건 </div>
									</div>
									<grid :options="compatibleList_grid" v-once />
									<div class="sub_left_wrap">
										<div class="btn_area">
											<a href="javascript:void(0)" class="button white" @click="compatibleListGridReset()">
												<span>초기화</span>
											</a>
										</div>
									</div>
									<div class="sub_right_wrap">
										<div class="btn_area dark">
											<a href="javascript:void(0);" class="button dark slide_close" @click="close()">
												<span>팝업닫기</span>
											</a>
											<a href="javascript:void(0)" class="button blue" @click="storeOrderItem()">
												<span>주문항목 담기</span>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
				</div>
			</div>
  </slidePopup>
</template>

<script>
import Vue from 'vue'
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid' 
import SlidePopup from '@/components/SlidePopup' 

const defaultRowCount = 50;
let newList = new Array(defaultRowCount);
let storeOrderItemList = [];
let dataEditFlag = true; // 중복 조회 방지 플래그
let slideOpenFlag = true; // 이벤트 중복 방지 플래그

export default {
	name: 'SknProductSrchPopup',
	components: { Grid, SlidePopup },
	props: {
		value: ''
	},
	data () {
		return {
			productListRowCnt: 0,
			compatibleListRowCnt: 0,
			chosenListRowCnt: 0,
			insurancePartNo: '',
			agentNo: 0,
			productList_grid: {
				general: {
					id: 'productList-grid',
					search : '',
          searchMethod : 'post',
					type: {
						isDataShow: false,
						isUpdate : true,
						isHideAdd : true,
						isHideUpdate : true,
						isHideDel: true,
						isHideReset: true
					},
					PageInfo: {

					},
					params: {
						searchText: ''
					}
				},
				grid_options: {
					height: '7row',
          fitTableWidth: true,
					numberingColumnFromZero: false,
					rowSelectOption: {
						clickSelect: true,
						singleSelect: true,
						disableSelectByKey: true
					},
					paging:{
						pagerTotal:false
					},
					header: true,
					headerGroup: [
						{fromIndex:1, toIndex:1, title:'No', id:'b', hideSubTitle: true},
						{fromIndex:2, toIndex:2, title:'상품코드', id:'c', hideSubTitle: true},
						{fromIndex:3, toIndex:3, title:'상품명', id:'d', hideSubTitle: true},
						{fromIndex:4, toIndex:4, title:'안성<br>물류', id:'e', hideSubTitle: true},
						{fromIndex:5, toIndex:5, title:'서울<br>물류', id:'f', hideSubTitle: true},
						{fromIndex:6, toIndex:7, title:'일반단가', id:'g', hideSubTitle: true},
						{fromIndex:8, toIndex:9, title:'보험단가', id:'h', hideSubTitle: true},
						{fromIndex:10, toIndex:10, title:'시중가', id:'i', hideSubTitle: true},
						{fromIndex:11, toIndex:11, title:'호환상품', id:'j', hideSubTitle: true},
						{fromIndex:12, toIndex:12, title:'이미지', id:'k', hideSubTitle: true}
					],
					columnMapping: [
						{key: 'id', hidden: true},
						{key: 'index', 												width: '35px',	align: 'center', numberingColumn: true},
						{key: 'product_id',										width: '120px',	align: 'center', defaultValue: '입력하세요.', editable: true, allowPaste: true},
						{key: 'product_name',									width: '210px',	align: 'center'},
						{key: 'anseong_logistics',						width: '45px',	align: 'center'},
						{key: 'seoul_logistics',							width: '45px',	align: 'center'},
						{key: 'nomal_price',									width: '75px',	align: 'center',  render: GridModule.numberCommaRender},
						{key: 'nomal_price_rate',							width: '33px',	align: 'center'},
						{key: 'chosen_insurance_price',				width: '75px',	align: 'center',  render: GridModule.numberCommaRender},
						{key: 'chosen_insurance_price_rate',	width: '33px',	align: 'center'},
						{key: 'market_price',									width: '63px',	align: 'center',  render: GridModule.numberCommaRender},
						{key: 'compatable_product_yn',				width: '63px',	align: 'center',
							render : function( value, data, render, mapping) {
								if ( value ) {
									return '<a href="javascript:void(0);"><div class="pro_ico"><span></span></div></a>';
								} else {
									return '';
								}
							}
						},
						{key: 'product_image_yn',						width: '63px',	align: 'center', styleclass : "bordr0",
							render : function( value, data, render, mapping) {
								if ( value == null ) {
									return '';
								} else if ( value ) {
									return '<a href="javascript:void(0);"><div class="o_ico"><span></span></div></a>';
								} else if ( !value ) {
									return '<div class="x_ico"><span></span></div>';
								}
							}
						}
					]
				}
			},
			compatibleList_grid: {
				general: {
					id: 'compatibleList-grid',
					search : '/billingCardMasterMng/cardlist',
					type: {
						isDataShow: false,
						isUpdate : true,
						isHideAdd : true,
						isHideUpdate : true,
						isHideDel: true,
						isHideReset: true
					},
					PageInfo: {

					},
					params: {
						searchText: ''
					},
					require_params : {
						params : ['searchText']
					}
				},
				grid_options: {
					height: '10row',
          fitTableWidth: true,
					numberingColumnFromZero: false,
					paging:{
						pagerTotal:false
					},
					columnMapping: [
						{key: 'id', hidden: true},
						{key: 'check',										width: '45px',							selectorColumn: true},
						{key: 'product_logo',							title: '로고',							width: '90px',	align: 'center'},
						{key: 'original_product_code',		title: '본래<br>상품코드',	width: '90px',	align: 'center'},
						{key: 'compatable_product_code',	title: 'SKN<br>상품코드',		width: '130px',	align: 'center'},
						{key: 'product_name',							title: '상품명',						width: '144px',	align: 'center'},
						{key: 'anseong_logistics',				title: '안성<br>물류',			width: '63px',	align: 'center'},
						{key: 'seoul_logistics',					title: '서울<br>물류',			width: '63px',	align: 'center'},
						{key: 'price_10',									title: '일반단가',					width: '90px',	align: 'center',  render: GridModule.numberCommaRender},
						{key: 'price_30',									title: '시중가',						width: '90px',	align: 'center',  render: GridModule.numberCommaRender},
						{key: 'order_amount',							title: '주문수량',					width: '90px',	align: 'center',	editable: true, styleclass : "bordr0"}
					]
				}
			}
		}
	},
	methods: {
		open(val) { // init
			storeOrderItemList = new Array;
			var trgtProductCodeList = this.toStringProductCode(val.toString().indexOf(',') > -1 ? val[0] : val)
			this.insurancePartNo = val.toString().indexOf(',') > -1 ? val[1] : null; // 보험사 번호
			this.agentNo = val.toString().indexOf(',') > -1 ? val[2] : null; // 대리점 번호

			this.$refs.slidePopup.open();
			var gridId = 'productList-grid';
			var gridUrl = '/sknProductSrch/productInfoList'

			//스크롤 컨트롤러
      $(".popup .scroll_area,.product_sh .scroll_area").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
			});
			
			// Skn 상품 그리드 초기셋팅
			for (var i = 0; i < defaultRowCount; i++) {
				newList[i] = {i};
			}
			$('#' + gridId).alopexGrid('dataSet', newList);
			
			this.productListRowCnt = $('#' + gridId).alopexGrid('pageInfo').rowCount;
			
      // 그리드 이벤트 생성 start
			if (!slideOpenFlag) { // 이벤트 중복 방지를 위해 설정
				return false;
			}
			
			// 1. 클릭이벤트
			$("#" + gridId).on('click', this.productListClick);

      // 2. 상품코드 직접입력
      var that = this;
      $('#'+ gridId).on( 'dataChanged' , (e) => this.typeProductCode(e));

      // 3. 상품코드 copy & paste
      $('#'+ gridId).on( 'paste' , (e) => this.pasteProductCode(e));

			// 그리드 이벤트 생성 end

			slideOpenFlag = false; // 이벤트 중복 방지 플래그
			
		},
		compatibleListGridReset() {
			// 초기화버튼 클릭시 -> 담은 주문항목은 초기화 아님?
			// 1. SKN 상품 그리드 초기화
			newList = new Array(defaultRowCount)
			$("#productList-grid").alopexGrid('dataEmpty');
			for (var i = 0; i < defaultRowCount; i++) {
				newList[i] = {i};
			}
			this.productListRowCnt = newList.length;
			$('#productList-grid').alopexGrid('dataSet', newList);

			// 2. 호환상품 그리드 초기화
			$("#compatibleList-grid").alopexGrid('dataEmpty');
			this.compatibleListRowCnt = 0;
		},
		close() {
			this.$refs.slidePopup.close();
    },
    getSknProduct(gridId, gridUrl, trgtProductCodeList, insurancePartNo, agentNo) {
			//Skn 상품 그리드 조회, 토탈카운트 셋팅을 위해 별도 조회

			if (insurancePartNo == null || insurancePartNo == undefined) insurancePartNo = 4;

			if (agentNo == null || agentNo == undefined) agentNo = 1;

			Vue.httpClient
				.post(gridUrl, {productLists: trgtProductCodeList, insurancePartNo: insurancePartNo, agentNo: agentNo})
				.then((result) => {
					var list = [];
					// 복붙을 위한 기본 셋팅
          if (result != undefined && result != null) {
						// 결과값 있을때 한줄 추가
            list = result.data.result.list;
          }
          
          $('#' + gridId).alopexGrid('dataSet', list);
          
					$('#' + gridId).alopexGrid('hideProgress', true);
					this.productListRowCnt = $('#' + gridId).alopexGrid('pageInfo').rowCount;
				})
				.catch((error) => { console.log(error); });
			
			this.compatibleListGridReset();
      this.compatibleListRowCnt = $('#compatibleList-grid').alopexGrid('pageInfo').rowCount;
		},
		searchProductInfo(grid_options) {
			// 상품 정보 조회
			const gridId = 'productList-grid';
			const gridUrl = '/sknProductSrch/productInfoList'
			let localInsurancePartNo = 4;
			let localAgentNo = 1;
      var data = $('#'+ grid_options.general.id).alopexGrid( 'dataGet', function(data) {
				return data.product_id != undefined && String(data.product_id) != '' && data.product_id != '입력하세요.' && data._state.edited != false;
			});
			
			if (data.length == 0) {
				return false;
			}

			if (this.insurancePartNo != null && this.insurancePartNo != undefined) localInsurancePartNo = this.insurancePartNo;

			if (this.agentNo != null && this.agentNo != undefined) localAgentNo = this.agentNo;

			Vue.httpClient
				.post(gridUrl, {productLists: data[data.length - 1].product_id, insurancePartNo: localInsurancePartNo, agentNo: localAgentNo})
				.then((result) => {
					if (result.data.result.list != 0) {
						$('#productList-grid').alopexGrid('dataEdit', result.data.result.list[0],{_index:{row:data[data.length - 1]._index.row}});
					} else {
						Vue.Alert.alert('조회된 상품정보가 없습니다.');
					}
					dataEditFlag = false;
				})
				.catch((e) => { console.log(e) })
				.then(() => {
					for (var i = 0; i < data.length; i++) {
						data[i]._state.edited = false;
					}
				});
    },
		typeProductCode(e) {
			// 상품 코드 입력시 정보조회
			let evObj = AlopexGrid.parseEvent(e);

			if (!dataEditFlag) {// 중복조회를 방지하는 플래그 확인
				dataEditFlag = true;
				return false;
			}

			//  1. 상품조회
			if (evObj.type == 'edit') {
				this.searchProductInfo(this.productList_grid);
			}
			//  2. 새줄 추가
			if (evObj.type == 'edit' 
					&& evObj.datalist[0]._index.row == this.productListRowCnt - 1
					&& evObj.datalist[0].card_number != evObj.datalist[0]._original.card_number) {
				$('#productList-grid').alopexGrid('dataAdd', {'i':51},{_index:{row:this.productListRowCnt}});
				this.productListRowCnt += 1;
			}
		},
		pasteProductCode(e) {
			// 상품코드 복붙시 정보조회
			const gridId = 'productList-grid';
			const gridUrl = '/sknProductSrch/productInfoList'
			let evObj = AlopexGrid.parseEvent(e);
			let beforeLast2Status = $('#productList-grid').alopexGrid( 'dataGetByIndex' , { row : this.productListRowCnt-2 } )._state.edited;
			let localInsurancePartNo = 4;
			let localAgentNo = 1;

			// 1. 뒤에서 2번째 row를 사용한 경우 신규생성
			let data = null; // 선택 데이터
			let hasNoResultFlag = false; // true인 경우 조회결과가 없는 데이터 존재, 얼럿 표시

			if (beforeLast2Status) {
				var addData = [];
				for (var i=0; i < defaultRowCount; i++) {
					addData[i] = {i: i}
					this.productListRowCnt += 1;
				}
				$('#productList-grid').alopexGrid('dataAdd', addData,{_index:{row:this.productListRowCnt}});
			}

			// 2. 조회
			data = $('#'+ gridId).alopexGrid( 'dataGet', function(data) {
				return data.product_id != undefined && String(data.product_id) != '' && data.product_id != '입력하세요.' && data._state.edited != false;
			});

			if (data.length == 0) {
				return false;
			}
			
			if (this.insurancePartNo != null && this.insurancePartNo != undefined) localInsurancePartNo = this.insurancePartNo;

			if (this.agentNo != null && this.agentNo != undefined) localAgentNo = this.agentNo;

			Vue.httpClient
				.post(gridUrl, {productLists: this.toStringProductCode(data), insurancePartNo: localInsurancePartNo, agentNo:localAgentNo})
				.then((result) => {
					if (result.data.result.list != 0) {
						// 상품코드 없는경우 빈칸으로 남겨두기 위해, 중복 상품코드 중복 표기를 위해 2중 포문
						for (var i=0; i < data.length; i++) {
							var dataProductId = data[i].product_id;
							for (var j=0; j < result.data.result.list.length; j++) {
								var resultProductId = result.data.result.list[j].product_id
								if (dataProductId == resultProductId) {
									dataEditFlag = false; // dataChanged 이벤트 발생 방지용 flag
									$('#productList-grid').alopexGrid('dataEdit', result.data.result.list[j],{_index:{row:data[i]._index.row}});
								} else { //true인 경우 조회결과가 없는 데이터 존재, 얼럿 표시
									hasNoResultFlag = true;
								}
							}
						}
					} else {//true인 경우 조회결과가 없는 데이터 존재, 얼럿 표시
						hasNoResultFlag = true;
					}
				})
				.catch((e) => { console.log(e) })
				.then(() => {
					if (hasNoResultFlag) Vue.Alert.alert('조회결과가 없는 데이터가 있습니다. 리스트를 확인해주세요.');
					for (var i = 0; i < data.length; i++) {
						data[i]._state.edited = false;
					}
				});
		},
		productListClick(e) { //상품 클릭시 호환 상품 조회
			var evObj = AlopexGrid.parseEvent(e);
			var gridId = 'compatibleList-grid';
			var gridUrl = '/sknProductSrch/compatibleProductInfoList'
			//상품코드 없으면 작동안하게 할것
			if(evObj.data == null || evObj.data == undefined || evObj.data.product_id == undefined
				|| evObj.data.product_id == '입력하세요.' || evObj.mapping.key !=  "compatable_product_yn" 
				|| !evObj.data.compatable_product_yn) {
				return false;
			}

			var trgtProductCode = evObj.data.product_id; // 호환상품 조회할 상품코드

			// 그리드 조회, 토탈카운트 셋팅을 위해 별도 조회
			Vue.httpClient
				.get(gridUrl, {params: {current: 1, perPage: 10, productCode: trgtProductCode}})
				.then((result) => {
					$('#' + gridId).alopexGrid('dataSet', result.data.result.list);
				})
				.catch((error) => { })
				.then(() => {
					$('#' + gridId).alopexGrid('hideProgress', true);
					this.compatibleListRowCnt = $('#' + gridId).alopexGrid('pageInfo').rowCount;
				});
		},
		storeOrderItem() {
			// 주문항목 담기, 중복 제거 필요?, 상품당 별건으로?
			var data = $('#compatibleList-grid').alopexGrid('dataGet', {_state: {edited:true}}, {_state:{selected:true}});
			
			this.chosenListRowCnt += data.length;
			storeOrderItemList = storeOrderItemList.concat(data);

			if (data == null || data.length == 0) {
				Vue.Alert.alert('선택된 항목이 없습니다. 항목을 선택해주세요.');
				return false;
			}

			$('#compatibleList-grid').alopexGrid('rowSelect', {_state : {selected:true}}, false);
			
			this.$emit('test-slide-complete', storeOrderItemList);
			this.$refs.slidePopup.close();
		},
		toStringProductCode(list) {
      //list에 포함된 상품 code ','로 결합된 String 반환
      if (typeof list === 'object' && list != null) {
        var trgtArray = [];
        for (var i = 0; i < list.length; i++) {
          trgtArray.push(list[i].product_id);
        }
        return trgtArray.toString();
			}
      return list;
		},
  },
  mounted: () => {
    // 1. 상품코드 직접입력을 위한 초기값
    for (var i=0; i < newList.length; i++) {
      newList[i] = {i};
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/common/SknProductSrchPopup.vue